export const getCapitalizedLang = (i18n: any) =>
  i18n.language.charAt(0).toUpperCase() + i18n.language.slice(1);
